import { Loading, useTranslation } from "@opendash/core";
import { Button, Col, Image, Result, Row } from "antd";
import React, { useMemo, useState } from "react";
import { useMedia } from "../..";

export function TicketImageCarousel() {
  const t = useTranslation();
  const [showImages, setShowImages] = useState<boolean>(false);
  const { loading, media } = useMedia();
  const imageUrls = useMemo(
    () => media?.map((media) => media.get("media")?.url()),
    [media]
  );

  const imagecontainerstyles: React.CSSProperties = {
    maxHeight: showImages ? "100%" : "300px",
    overflow: "hidden",
    transition: "max-height 0.5s",
    textAlign: "center",
  };
  const readmorecontainerstyles: React.CSSProperties = {
    height: "0px",
    position: "relative",
    cursor: "pointer",
  };
  const readmorebackgroundstyles: React.CSSProperties = {
    bottom: "0px",
    height: "60px",
    position: "absolute",
    zIndex: 30,
    width: "100%",
    background: showImages
      ? "none"
      : "linear-gradient(rgba(251, 251, 251, 0), rgb(255, 255, 255))",
  };

  const toggleImages = () => {
    setShowImages(!showImages);
  };

  return (
    <>
      <div style={{ marginTop: 150 }}>
        <div style={{ ...imagecontainerstyles }}>
          {loading && <Loading message={t("maintenance:global.loading")} />}
          {imageUrls.length > 0 && (
            <Row gutter={[16, 16]} justify="start" align="top">
              {imageUrls.map((image, index) => {
                return (
                  <Col key={index} span={8}>
                    <Image src={image} />
                  </Col>
                );
              })}
            </Row>
          )}
        </div>

        {imageUrls.length > 0 && !loading ? (
          <div style={{ ...readmorecontainerstyles }}>
            <div style={{ ...readmorebackgroundstyles }} />
            <Button
              type="dashed"
              block
              style={{ marginTop: "10px" }}
              onClick={toggleImages}
            >
              {showImages
                ? t("maintenance:media.wrapper.less")
                : t("maintenance:media.wrapper.more")}
            </Button>
          </div>
        ) : (
          <Result title={t("maintenance:media.empty")} />
        )}
      </div>
    </>
  );
}
